import { render, staticRenderFns } from "./VideoParallax2.vue?vue&type=template&id=da3505a0&scoped=true"
import script from "./VideoParallax2.vue?vue&type=script&lang=js"
export * from "./VideoParallax2.vue?vue&type=script&lang=js"
import style0 from "./VideoParallax2.vue?vue&type=style&index=0&id=da3505a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3505a0",
  null
  
)

export default component.exports